export const environmentBase = {
  production: true,
  appVersion: '{APP_VERSION}',
  appBuildNumber: '{APP_BUILD_NUMBER}',
  auth: {
    responseType: 'code',
    pkceEnabled: true,
    additionalParameters: {
      ui_locales: 'it',
    },
  },
  privacyPolicyUrl: 'https://stfmatest002.blob.core.windows.net/privacy/INFORMATIVA_APP_FMA.html',
  googleMapsApiKey: 'AIzaSyAkoLmpVxKCyMaYshdSIsTy92e5Jk-liy4', // NOTE: THIS KEY IS ALSO LOCATED IN AndroidManifest
};
